import { useAuthContext } from "contexts/JWTAuth";
import { useCallback, useMemo } from "react";

const useNavigationAuth = () => {
    const { profile } = useAuthContext();

    // Memoize user authorization data
    const authData = useMemo(() => {
        if (!profile) return null;

        return {
            isSuperuser: profile.is_superuser,
            groups: profile.groups?.map((group) => group.name) || [],
            permissions: profile.permissions || [],
            clientTypes: profile.client_types || []
        };
    }, [profile]);

    // Authorization check function - memoized
    const checkItemAuthorization = useCallback((item) => {
        if (!authData) return false;

        const { isSuperuser, groups, permissions, clientTypes } = authData;

        // Check groups
        let hasGroups = false;
        if (groups && item.groups) {
            hasGroups = groups.some((group) => item.groups.includes(group)) &&
                !groups.some((group) => item.groups.includes("!" + group));
        } else if (!item.groups) {
            hasGroups = true;
        }

        if (!hasGroups && !isSuperuser) {
            return false;
        }

        // Check permissions
        if (item.auth && item.auth !== "all") {
            const hasPermission = permissions.some((perm) =>
                item.auth.includes(perm.codename)
            );
            if (!hasPermission && !isSuperuser) {
                return false;
            }
        }

        // Check client types
        const itemClientTypes = item.client_types || [];
        if (itemClientTypes.length > 0) {
            const hasClientType = clientTypes.some((ct) => {
                return itemClientTypes.includes(ct);
            });
            if (!hasClientType) {
                return false;
            }
        }

        return true;
    }, [authData]);

    return { checkItemAuthorization, profileLoaded: !!profile };
};

export default useNavigationAuth;
